/* global System */
// register component(s) with react habitat

export default { BeforeAfterSlider: () => System.import('./data') }
